var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextContains(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50136 5.456H7.08136V6.392H5.70136V15.248H7.08136V16.184H4.50136V5.456ZM16.9188 16.184V15.248H18.2988V6.392H16.9188V5.456H19.4988V16.184H16.9188Z",
    fill: "#1D6295"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3443 7.94H9.0243V6.88H14.9743V7.94H12.6443V14H11.3443V7.94Z",
    fill: "#1D6295"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 19,
    rx: 2.5,
    stroke: "#1D6295"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextContains);
export default __webpack_public_path__ + "static/media/text_contains.34bb219a7d14a6231f8c5d770b5d88a6.svg";
export { ForwardRef as ReactComponent };